<template>
  <div class="page-wrap">
    <div class="session-form-hold">
      <base-card>
        <v-card-text class="text-center" v-show="verifyCardHide">
          <div class="py-1">
            <h5 class="font-weight-bold">Admin</h5>
            <v-text-field type="password" label="Passcode" v-model="passCode" />
            <v-btn block color="primary" @click="verify"> Verify </v-btn>
          </div>
        </v-card-text>

        <v-card-text class="text-center" v-show="registerCardHide">
          <div class="py-1">
            <h5 class="font-weight-bold">Renew Subscription</h5>
            <p class="text--disabled font-weight-medium">
              Please check with the plan subscription with admin
            </p>
          </div>
          <v-autocomplete
            v-model="selectedCompany"
            label="Company"
            item-text="company_name"
            item-value="company_id"
            :items="companyList"
            :error-messages="selectedCompanyErrors"
            required
            @input="$v.selectedCompany.$touch()"
            @blur="$v.selectedCompany.$touch()"
          ></v-autocomplete>

          <v-select
            v-model="selectedPlan"
            :items="items"
            label="Subscription Plan"
            :item-text="getFieldText"
            return-object
            :error-messages="selectedPlanErrors"
            required
            @input="$v.selectedPlan.$touch()"
            @blur="$v.selectedPlan.$touch()"
          ></v-select>

          <v-select
            v-model="selectedDealer"
            :items="dealers"
            label="Dealer"
            item-text="company"
            return-object
            :error-messages="selectedDealerErrors"
            required
            @input="$v.selectedDealer.$touch()"
            @blur="$v.selectedDealer.$touch()"
          ></v-select>

          <div>
            <v-row>
              <v-col>
                <v-text-field
                  label="Discount Rate"
                  v-model="dRate"
                  type="number"
                  :error-messages="dRateErrors"
                  @input="$v.dRate.$touch()"
                  @blur="$v.dRate.$touch()"
                />
              </v-col>
              <v-col>
                <v-text-field
                  label="Commission Rate"
                  v-model="cRate"
                  type="number"
                  :error-messages="cRateErrors"
                  @input="$v.cRate.$touch()"
                  @blur="$v.cRate.$touch()"
                />
              </v-col>
            </v-row>
          </div>

          <v-btn
            class="mb-4"
            block
            @click="getLatestSubscription"
            color="primary"
            >Renew</v-btn
          >
          <!-- <div class="">
            Already have an account ?
            <v-btn text small color="primary" to="/app/sessions/login"
              >Sign In</v-btn
            >
          </div> -->
        </v-card-text>

        <!-- error password snackbar  -->
        <v-snackbar v-model="snackbar" top :color="sColor">
          {{ message }}
          <template v-slot:action="{ attrs }">
            <v-btn color="" text v-bind="attrs" @click="snackbar = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </template>
        </v-snackbar>
      </base-card>
    </div>
  </div>
</template>
  <script>
import { BASEURL, BASESYNCURL } from "@/api/baseurl";
import axios from "axios";
import { validationMixin } from "vuelidate";
import { required, minValue } from "vuelidate/lib/validators";

export default {
  name: "renew",
  metaInfo: {
    // title will be injected into parent titleTemplate
    title: "renew",
  },
  mixins: [validationMixin],

  validations: {
    selectedPlan: { required },
    selectedCompany: { required },
    selectedDealer: { required },
    dRate: { minValue: minValue(0) },
    cRate: { minValue: minValue(0) },
  },

  data() {
    return {
      domain: BASEURL,
      syncDomain: BASESYNCURL,
      show: false,
      checkbox: false,
      email: "",
      message: "",
      password: "",
      name: "",
      bName: "",
      selectedCompany: "",
      loading: false,
      snackbar: false,
      sColor: "",
      emailExist: "",
      items: [],
      dealers: [],
      companyList: [],
      selectedPlan: "",
      passCode: "",
      correctPasscode: "",
      registerCardHide: false,
      verifyCardHide: true,
      selectedDealer: "",
      dRate: "",
      cRate: "5",
    };
  },
  created() {
    this.getAllCompany();
    this.getAllSubscriptionPlan();
    this.getAllDealer();
    this.fetchPasscode();
  },

  computed: {
    selectedPlanErrors() {
      const errors = [];
      if (!this.$v.selectedPlan.$dirty) return errors;
      !this.$v.selectedPlan.required &&
        errors.push("Subscription Plan is required.");
      return errors;
    },
    selectedCompanyErrors() {
      const errors = [];
      if (!this.$v.selectedCompany.$dirty) return errors;
      !this.$v.selectedCompany.required && errors.push("Company is required.");
      return errors;
    },

    selectedDealerErrors() {
      const errors = [];
      if (!this.$v.selectedDealer.$dirty) return errors;
      !this.$v.selectedDealer.required && errors.push("Dealer is required.");
      return errors;
    },
    dRateErrors() {
      const errors = [];
      if (!this.$v.dRate.$dirty) return errors;

      !this.$v.dRate.minValue && errors.push("Minimum Discount rate is 0");

      return errors;
    },

    cRateErrors() {
      const errors = [];
      if (!this.$v.cRate.$dirty) return errors;

      !this.$v.cRate.minValue && errors.push("Minimum Commission rate is 0");
      return errors;
    },
  },
  watch: {
    selectedDealer() {
      this.dRate = this.selectedDealer.discount_rate;
    },
  },

  methods: {
    async fetchPasscode() {
      try {
        const response = await axios.get("/api/passcode");
        this.correctPasscode = response.data;
      } catch (error) {
        console.error("Failed to fetch mock passcode", error);
      }
    },

    verify() {
      if (this.passCode == this.correctPasscode) {
        this.snackbar = true;
        this.sColor = "success";
        this.message = "Verified Admin";
        this.verifyCardHide = false;
        this.registerCardHide = true;
      } else {
        this.snackbar = true;
        this.sColor = "danger";
        this.message = "Not Authorised Admin";
      }
    },

    getAllCompany() {
      const params = new URLSearchParams();
      params.append("read", "done");
      axios({
        method: "post",
        url: this.domain + "/company/index.php",
        data: params,
      })
        .then((response) => {
          console.log(response);
          if (response.data.status == "1") {
            this.companyList = response.data.company;
          } else {
            this.companyList = [];
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getLatestSubscription() {
      const params = new URLSearchParams();
      params.append("read", "done");
      params.append("company_id", this.selectedCompany);
      axios({
        method: "post",
        url: this.domain + "/subscription/index.php",
        data: params,
      })
        .then((response) => {
          console.log(response);
          if (response.data.status == "1") {
            var latestSubscription = response.data.subscription;
            var start_date = latestSubscription[0]["end_date"];
            this.renew(start_date);
          } else {
            var moment = require("moment");
            var start_date = moment().format("YYYY-MM-DD");
            this.renew(start_date);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getCompanyBranch(company_id) {
      const params = new URLSearchParams();
      params.append("getCompanyBranch", "done");
      params.append("company_id", company_id);

      axios({
        method: "post",
        url: this.domain + "/branch/index.php",
        data: params,
      })
        .then((response) => {
          console.log(response);
          if (response.data.status == "1") {
            var branchList = response.data.branch;
            for (let i = 0; i < branchList.length; i++) {
              this.sendNotication(branchList[i].branch_id);
            }
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getAllSubscriptionPlan() {
      const params = new URLSearchParams();
      params.append("readAllSubscription", "done");
      axios({
        method: "post",
        url: this.domain + "/subscription/index.php",
        data: params,
      })
        .then((response) => {
          console.log(response);
          if (response.data.status == "1") {
            this.items = response.data.subscription;
          } else {
            this.items = [];
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getAllDealer() {
      const params = new URLSearchParams();
      params.append("getAllDealer", "done");
      axios({
        method: "post",
        url: this.domain + "/company/index.php",
        data: params,
      })
        .then((response) => {
          console.log(response);
          if (response.data.status == "1") {
            this.dealers = response.data.dealer;
          } else {
            this.dealers = [];
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getFieldText(item) {
      return `${item.subscription_package} - RM${item.subscription_fee} - ${item.duration} months - ${item.branch_amount} branch`;
    },

    renew(start_date) {
      var moment = require("moment");
      var startDate = moment(start_date).format("YYYY-MM-DD");
      var endDate = moment(startDate)
        .add(this.selectedPlan.duration, "M")
        .format("YYYY-MM-DD");
        
      this.$v.$touch();
      if (!this.$v.$invalid) {
        const params = new URLSearchParams();
        params.append("renew_subscription_new", "done");
        params.append("company_id", this.selectedCompany);
        params.append("subscription_plan_id", this.selectedPlan.id);
        params.append("subscription_package", this.selectedPlan.subscription_package);
        params.append("subscription_fee", this.selectedPlan.subscription_fee);
        params.append("duration", this.selectedPlan.duration);
        params.append("branch_amount", this.selectedPlan.branch_amount);
        params.append("start_date", startDate);
        params.append("end_date", endDate);
        params.append("dealer_id", this.selectedDealer.dealer_id);
        params.append("discount_rate", this.dRate ? this.dRate : 0);
        params.append("commision_rate", this.cRate ? this.cRate : 0);
        params.append("sale_by", this.selectedDealer.company);
        params.append("based_amount", (this.selectedPlan.subscription_fee*((100-this.dRate)/100)).toFixed(2));
        params.append("commision_amount", ((this.selectedPlan.subscription_fee*((100-this.dRate)/100))*(this.cRate/100)).toFixed(2));
        axios({
          method: "post",
          url: this.domain + "/subscription/index.php",
          data: params,
        })
          .then((response) => {
            console.log(response);
            if (response.data.status == "1") {
              this.snackbar = true;
              this.sColor = "success";
              this.message = "Successfully renew account.";
              this.getCompanyBranch(this.selectedCompany);
              this.selectedCompany = "";
              this.selectedPlan = "";
              this.selectedDealer = "";
              this.dRate = "";
              this.cRate = "5";
              this.$v.$reset()

            } else {
              this.snackbar = true;
              this.sColor = "danger";
              this.message = "Something went wrong. Please try again";
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    sendNotication(branch_id) {
      const params = new URLSearchParams();
      params.append("send_notification", "done");
      params.append("branch_id", branch_id);
      params.append("type", "1");

      axios({
        method: "post",
        url: this.syncDomain + "/sync/index.php",
        data: params,
      })
        .then((response) => {
          console.log(response);
          if (response.data.status == "1") {
            console.log("Send Notification successfully");
          } else {
            console.log("Send Notification fail");
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
};
</script>
  <style lang="scss" scoped>
.page-wrap {
  background-color: #242939 !important;
  display: flex;
  align-items: center;
  padding: 40px 1rem;
  height: 100%;
  min-height: 100vh;
}
.session-form-hold {
  width: 100%;
  max-width: 400px;
  margin: 0 auto;
}
</style>
  